import React from 'react';

import { SidebarItems } from '@/modules/corporate/modules/admin/hooks/useSidebar';

import { UnifiedNav } from '../types';

export function toSidebarItems(nav: UnifiedNav): SidebarItems {
  return nav.map((section) => ({
    id: section.id,
    children: section.items.map((item) => {
      const Icon = item.icon;

      return {
        id: item.id,
        text: item.label,
        badge: item.badge,
        icon: Icon ? <Icon className="h-18 w-18" strokeWidth={1.2} /> : undefined,
        to: item.href,
        enabled: true,
        isDisabled: item.isDisabled,
        routes: item.matchPrefix ? undefined : item.href ? [item.href] : undefined,
        children: item.groups?.flatMap((group) =>
          group.items.map((subItem) => {
            const SubIcon = subItem.icon;

            return {
              id: subItem.id,
              text: subItem.label,
              icon: SubIcon ? <SubIcon className="h-18 w-18" strokeWidth={1.2} /> : undefined,
              to: subItem.href,
              enabled: true,
              isDisabled: subItem.isDisabled,
              groupId: group.id,
            };
          }),
        ),
      };
    }),
  }));
}
